import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { onDemandReducer } from './on-demand.reducer';
import { OnDemandEffects } from './on-demand.effects';

@NgModule({
  imports: [StoreModule.forFeature('onDemand', onDemandReducer), EffectsModule.forFeature([OnDemandEffects])],
})
export class OnDemandStoreModule {}
